export const NAMES = {
  TAG_NAME: "ab-picture-sets",
  CHILD_SET_TAG_NAME : "ab-picture-set",
  PICTURE_SINGLE_TAG_NAME: 'ab-picture-single',
  IMAGE_CLASS: 'home__featured-image',
}